import React from 'react';
import { Grid } from '@mui/material';


export const DashboardCartocor = () => {

    const clientData = JSON.parse(localStorage.getItem("clientData"))
    const imgUrl = clientData.dominio + '/static_content/img/' + clientData.owner_code + '_LOGO.png'
    let useCognito = JSON.parse(localStorage.getItem("cognitoUse"));
    console.log("useCognito", useCognito)
    return (
        <div>
            <Grid container justifyContent="center" alignItems="center" style={{ height: '90vh' }}>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <img src={imgUrl} alt="Bienvenido" style={{ maxWidth: '100%', height: 'auto', marginBottom: 20 }} />
                </Grid>
            </Grid>

        </div>
    );
};
